import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

const BoxCarouselComposition = (props) => {
  const itemCount = props.children.length;

  // Determine whether infinite scrolling should be enabled based on item count
  const isInfinite = itemCount > 4;

  const settings = {
    infinite: isInfinite,  // Enable infinite if there are more than 4 items
    autoplay: true,
    speed: 600,
    autoplaySpeed: 3000,
    slidesToShow: 1,  // Default to showing one slide at a time
    slidesToScroll: 1,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          infinite: isInfinite,  // Apply infinite based on item count
        },
      },
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 4,
          infinite: isInfinite,  // Apply infinite based on item count
        },
      },
      {
        breakpoint: 1920,
        settings: {
          slidesToShow: 5,
          infinite: isInfinite,  // Apply infinite based on item count
        },
      },
      {
        breakpoint: 2560,
        settings: {
          slidesToShow: 6,
          infinite: isInfinite,  // Apply infinite based on item count
        },
      }
    ],
  };

  return (
    <Slider {...settings}>
      {props.children}
    </Slider>
  );
};

export default BoxCarouselComposition;
